import React from 'react'

function UpdateComponent({ lebel,inputText,handleChange,handleClick,buttonlabel}) {
  return (
    <div>
          <label className="label">Update { lebel}</label>

                <div className="field has-addons">
                    <div className="control">
                        <input className="input" type="text" value={inputText} onChange={handleChange}  placeholder={`Update ${buttonlabel?buttonlabel:lebel}`} />
                    </div>
                    <div className="control">
                  <button className="button is-primary" onClick={handleClick} >Update {buttonlabel?buttonlabel:lebel }</button>
                    </div>
                </div>
            </div>
  )
}

export default UpdateComponent;